import Vue from 'vue';
import { mapGetters } from 'vuex';
import linkPage from '@editor/droplets/_bubble-options/components/link-page';
import { cardShape } from '@editor/droplets/utils';

export default Vue.component('edit-cardsTall', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['currentPage', 'currentSite', 'viewport']),
    minCount() {
      return this.droplet.cards.length < 2;
    },
    maxCount() {
      return this.droplet.cards.length >= this.cardLimit;
    },
    cards() {
      return this.droplet.cards;
    },
  },
  components: {
    linkPage,
  },
  data() {
    return {
      cardLoading: false,
      activeCard: null,
      paginate: ['cards'],
      cardLimit: 9,
      editLinkForm: false,
    };
  },
  name: 'edit-cardsTall',
  props: ['droplet', 'show-edit-bubble'],
  methods: {
    addCard() {
      const newCard = cardShape({ type: 'droplet.cardsTall.cardItem' })();
      const payload = {};
      payload.drp = this.droplet;
      payload.newCard = newCard;
      this.$store.dispatch('addNewTallCard', payload);
      this.$emit('css-generator');
    },
    removeCard(card, i) {
      const total = this.droplet.cards.length;
      if (total > 1) {
        this.$store.dispatch('spliceDropletVal', {
          array: this.droplet.cards,
          index: i,
        });
        this.$emit('css-generator');
        if (this.activeCard && card._id === this.activeCard._id) {
          this.resetFormValues();
        }
      }
    },
    bounceCard() {
      this.cardLoading = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          this.cardLoading = false;
          resolve();
        }, 250);
      });
    },
    async setFormValues(card) {
      this.activeCard = card;
      this.editLinkForm = true;
      await this.bounceCard();
    },
    async resetFormValues() {
      this.activeCard = null;
      this.editLinkForm = false;
      await this.bounceCard();
    },
    // our global _DropletOptions calls this on cancel if
    // we want any data options in this component reverted
    drzRevertData() {
      this.resetFormValues();
      this.$emit('css-generator');
    },
    drzClickSave() {
      this.resetFormValues();
    },
    setBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-tall/components/_edit-options/index.js